<script setup lang="ts">
import dayjs from 'dayjs'

const visibleDialog = ref(false)
function onClick() {
  onClose()
  navigateTo('https://market-zh.gloda.vip/', { open: { target: '_blank' } })
}
const time = useLocalStorage<number>('marketOnlineTime', null)
function onClose() {
  time.value = dayjs().valueOf()
  visibleDialog.value = false
}
onMounted(() => {
  if (isShowDialog()) {
    visibleDialog.value = true
  }
})
// 判断marketOnlineTime跟现在的时间是不是想差48小时
function isShowDialog() {
  if (!time.value)
    return true
  const now = dayjs().valueOf()
  const diff = now - time.value
  return diff > 48 * 60 * 60 * 1000
}
</script>

<template>
  <a-modal
    v-model:visible="visibleDialog"
    hide-title
    :footer="false"
    width="524px"
    :mask-closable="false"
    class="market-on-line-modal"
  >
    <div class="relative flex flex-col items-center">
      <img src="~/assets/images/MarketOnLineDialog.png" class="h-auto w-524 cursor-pointer" alt="东南亚报告上线" @click="onClick">
      <div class="absolute top-20 h-32 w-32 flex cursor-pointer items-center justify-center rounded-full bg-[rgba(0,0,0,0.32)] text-16 text-white transition-all -right-9 hover:bg-[--color-fill-10]" @click="onClose">
        <i class="icon-shanchu" />
      </div>
    </div>
  </a-modal>
</template>

<style lang="less">
.market-on-line-modal {
  .arco-modal-mask {
    background: rgba(0, 0, 0, 0.60);
  }
  .arco-modal {
    background-color: transparent;
  }
  &__title {
    color: #fff;
  }
}
</style>
